import { useQuery } from "@tanstack/react-query";
import { clientUsersClientesApi } from "./axios";

const getClientUsersClientes = async (urlConcat:string | null) => {
    
    if(urlConcat){
        const { data } = await clientUsersClientesApi.get(urlConcat);
        return data;
    }

    const { data } = await clientUsersClientesApi.get(''); 
    return data;
    
}

export const useClientUsersClientes = (urlConcat:string | null)=>{

    const clientUsersClientesQuery = useQuery(
        ["client-users-clients"],
        ()=>getClientUsersClientes(urlConcat),
        {
            refetchOnWindowFocus:false
        }
    );


    return {
        clientUsersClientesQuery
    };
}